// Global Types
import type {
  $Children,
  $GeoLocation,
} from 'common.types';
import type {
  $Translate,
} from 'common.language';

// Global Components
import * as React from 'react';
import {
  Button,
  Col,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap';

// Helpers
import Coordinates from 'coordinate-parser';
import formatcoords from 'formatcoords';

// Types
type $Props = $Translate & {
  action: (arg0: $GeoLocation) => unknown;
  children: $Children;
  id: string;
  title: string;
  value: $GeoLocation;
};

type $State = {
  stringValue: string;
  validValue: boolean;
  value: $GeoLocation;
  visible: boolean;
};

class GeoDialogView extends React.Component<$Props, $State> {
  constructor(props: $Props) {
    super(props);

    this.state = {
      stringValue: `${String(props.value.lat)} ${String(props.value.lng)}`,
      validValue: true,
      value: props.value,
      visible: false,
    };
  }

  toggle(): void {
    this.setState((prevState: $State) => ({
      visible: !prevState.visible,
    }));
  }

  childrenWithToggleHandler() {
    const {
      children,
    } = this.props;

    if (React.isValidElement(children)) {
      return React.cloneElement(
        children,
        {
          // @ts-expect-error dialog
          onClick: () => this.toggle(),
        },
      );
    }

    return children;
  }

  render() {
    const {
      action,
      id,
      t,
      title,
    } = this.props;
    const {
      stringValue,
      validValue,
      value,
      visible,
    } = this.state;

    const stringCoords: Array<string> = formatcoords([value.lat, value.lng]).format({
      latLonSeparator: 'x',
    }).split('x');

    return (
      <>
        {this.childrenWithToggleHandler()}
        <Modal
          centered
          id={id}
          isOpen={visible}
          size={'sm'}
          toggle={() => this.toggle()}
        >
          <ModalHeader>
            <p className={'mb-0'}>
              {title}
            </p>
            <small>
              {t('Location')}
            </small>
          </ModalHeader>
          <ModalBody>
            <div className={'mb-2'}>
              <Input
                id={'Coordinates'}
                invalid={!validValue}
                onChange={(e) => {
                  const newStringValue = e.target.value;

                  this.setState(
                    {
                      stringValue: newStringValue,
                      validValue: false,
                    },
                    () => {
                      const position = new Coordinates(newStringValue);

                      const lat: number = position.getLatitude();
                      const lng: number = position.getLongitude();

                      if (lat && lng) {
                        this.setState({
                          validValue: true,
                          value: {
                            lat,
                            lng,
                          },
                        });
                      }
                    },
                  );
                }}
                type={'text'}
                value={stringValue}
              />
            </div>
            <Row>
              <Col>
                <div className={'lh-1'}>
                  <div>
                    <small>
                      {stringCoords[0]}
                    </small>
                    <br />
                    <small>
                      {stringCoords[1]}
                    </small>
                  </div>
                </div>
              </Col>
              <Col className={'lh-1'}>
                <div className={'text-right'}>
                  <small>
                    {value.lat}
                  </small>
                  <br />
                  <small>
                    {value.lng}
                  </small>
                </div>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button
              color={'warning'}
              disabled={!validValue}
              onClick={() => action(value) && this.toggle()}
            >
              {t('Save')}
            </Button>
            <Button
              color={'secondary'}
              onClick={() => this.toggle()}
            >
              {t('Close')}
            </Button>
          </ModalFooter>
        </Modal>
      </>
    );
  }
}

export default GeoDialogView;
